/** Utstyrsregisteret (VIB-2917): statuser og kategorier. */

export type EquipmentStatus = "ok" | "in_service" | "missing" | "sold" | "retired";

export const EQUIPMENT_STATUS_LABELS: Record<EquipmentStatus, string> = {
  ok: "Tilgjengelig",
  in_service: "På service",
  missing: "Savnet",
  sold: "Solgt",
  retired: "Utrangert",
};

export const EQUIPMENT_STATUSES = Object.keys(EQUIPMENT_STATUS_LABELS) as EquipmentStatus[];

/**
 * De 13 kategoriene fra verktøyet (Erik 24.10). Samme liste seedes i
 * migrasjonen 20261024180000_equipment_register.sql; importskriptet legger inn
 * manglende rader herfra, fordi staging tømmes og fylles fra prod hver natt.
 */
export const EQUIPMENT_CATEGORIES: readonly { name: string; sort_order: number; bookable: boolean }[] = [
  { name: "Kamera", sort_order: 1, bookable: true },
  { name: "Objektiv og filter", sort_order: 2, bookable: true },
  { name: "Monitor og trådløst", sort_order: 3, bookable: true },
  { name: "Batterier og strøm", sort_order: 4, bookable: true },
  { name: "Lyd", sort_order: 5, bookable: true },
  { name: "Lys", sort_order: 6, bookable: true },
  { name: "Stativer og bevegelse", sort_order: 7, bookable: true },
  { name: "Grip og diverse", sort_order: 8, bookable: true },
  { name: "Lagring", sort_order: 9, bookable: true },
  { name: "Drone", sort_order: 10, bookable: true },
  { name: "Datamaskiner", sort_order: 11, bookable: false },
  { name: "Oppbevaring", sort_order: 12, bookable: true },
  { name: "Privat utstyr", sort_order: 13, bookable: false },
];

export const DEPARTMENT_NAMES = ["Oslo", "Bergen"] as const;

/** Servicesaker (VIB-2921). */
export type ServiceTicketStatus = "open" | "at_vendor" | "resolved";

export const SERVICE_STATUS_LABELS: Record<ServiceTicketStatus, string> = {
  open: "Åpen",
  at_vendor: "Hos verksted",
  resolved: "Ferdig",
};
